"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionTimeout = void 0;
var react_idle_timer_1 = require("react-idle-timer");
var SessionTimeout = function (_a) {
    var timeout = _a.timeout, handleOnSessionTimeout = _a.handleOnSessionTimeout;
    (0, react_idle_timer_1.useIdleTimer)({
        timeout: timeout,
        onIdle: handleOnSessionTimeout,
    });
    return null;
};
exports.SessionTimeout = SessionTimeout;
//# sourceMappingURL=SessionTimeout.js.map